import { useContextSelector } from 'use-context-selector';
import useWindowSize from '@hooks/use-window-size';
import headerStyles from '@components/organisms/header/header.module.scss';
import { CatalogContext } from '@context/catalog.context';
import React, { useRef } from 'react';
import clsx from 'clsx';
import styles from '@components/catalog/filter-section.module.scss';
import { CSSTransition } from 'react-transition-group';
import { ENTERED, ENTERING, EXITING } from 'react-transition-group/Transition';
import dynamic from 'next/dynamic';
import CloseButton from '@components/atoms/close-button/close-button';
import { useTranslation } from 'next-i18next';
import FilterLoadingState from '@components/catalog/filter-loading-state/filter-loading-state';

interface FilterSectionWrapperProps {
  areMobileFiltersOpened: boolean;
  setAreMobileFiltersOpened: (state: boolean) => void;
}

const FilterSection = dynamic(() => import('@components/catalog/filter-section'), {
  ssr: false,
  loading: () => <FilterLoadingState />,
});

const FilterSectionWrapper: React.FC<FilterSectionWrapperProps> = ({
  areMobileFiltersOpened,
  setAreMobileFiltersOpened,
}) => {
  const nodeRef = useRef(null);
  const { isWiderThanMd } = useWindowSize();
  const headerHeight = headerStyles?.desktopHeight || 0;
  const { t } = useTranslation();

  const shouldShowLoadingAnimation = useContextSelector(CatalogContext, (v) => v.shouldShowLoadingAnimation);

  const mobileContainerRef = useRef(null);
  return (
    <div
      className={clsx(styles.columnFilters, styles.filterUiRework, styles.stickyScrollbar, {
        [styles.open]: areMobileFiltersOpened,
      })}
      ref={mobileContainerRef}
      style={{
        top: isWiderThanMd ? headerHeight : undefined,
      }}
    >
      <div className={clsx(styles.columnFilters__header, 'vc-d-md-none')}>
        {t('CATALOG.FILTER_BY')}
        <CloseButton handleClick={() => setAreMobileFiltersOpened(false)} />
      </div>
      {shouldShowLoadingAnimation ? (
        <FilterLoadingState />
      ) : (
        <CSSTransition
          in={isWiderThanMd || areMobileFiltersOpened}
          timeout={300}
          nodeRef={nodeRef}
          unmountOnExit
        >
          {(transitionState) =>
            [ENTERED, ENTERING, EXITING].includes(transitionState) ? (
              <FilterSection
                setAreMobileFiltersOpened={setAreMobileFiltersOpened}
                mobileContainerRef={mobileContainerRef}
              />
            ) : null
          }
        </CSSTransition>
      )}
    </div>
  );
};

export default FilterSectionWrapper;
